import React from 'react';
import { Link } from 'react-router-dom';
import eliImage from '../assets/eli.JPG'; // Using a placeholder image

const Dance: React.FC = () => {
  return (
    <div className="container my-5">
      <div className="row text-center mb-5">
        <div className="col">
          <h1>Dance Classes</h1>
          <p className="lead">Learn to dance with the best in the Greater Seattle Area.</p>
        </div>
      </div>

      <div className="row mb-5 align-items-center">
        <div className="col-md-4 d-flex justify-content-center">
          <div className="dance-img-frame">
            <img
              src={eliImage}
              alt="Eli, the dance instructor"
              className="img-fluid dance-img"
            />
          </div>
        </div>
        <div className="col-md-8">
          <h2>Meet Your Instructor</h2>
          <p>
            Eli Noudelman is a 17-year-old Latin American dancer with extensive competitive experience in both national and international arenas. Achievements include 2024 U.S. National Finalist, a quarterfinalist at the 2024 Blackpool Dance Festival, and a consistent finalist in major dance competitions across the United States. Training reflects a strong emphasis on technical precision, musicality, and performance quality. Committed to fostering excellence, discipline, and artistic growth in developing dancers.
          </p>
        </div>
      </div>

      <div className="row">
        <div className="col">
          <h2>Class Details</h2>
          <p><strong>Location:</strong> Available online and in-person. The in-person address is: "Dance School Infiniti, 12815 NE 124th St Unit O, Kirkland, WA 98034".</p>
          <p><strong>Schedule:</strong> Select your top three preferred dates and times and we will get back to you shortly!</p>
          <p><strong>Pricing:</strong> $40 per class. Packages are also available.</p>
          <p><strong>Duration:</strong> 45 minutes.</p>
        </div>
      </div>

      <div className="row text-center mt-5">
        <div className="col">
          <h2>Ready to Dance?</h2>
          <p>Book your first class today and discover the joy of dancing!</p>
          <Link to="/book/dance-class" className="btn btn-primary btn-lg">Book a Dance Class</Link>
        </div>
      </div>
    </div>
  );
};

export default Dance;


